// Patient form validation — called on submit in NewPatientModal.

export interface PatientFormErrors {
  full_name?: string;
  age?: string;
  date_of_birth?: string;
  primary_phone?: string;
  emergency_contact_name?: string;
  emergency_contact_phone?: string;
  address?: string;
  city?: string;
  state?: string;
  enrolment_date?: string;
  chronic_conditions?: string;
}

function validName(raw: string): boolean {
  // Letters (any script), spaces, hyphens, apostrophes — min 2 chars
  return /^[\p{L}\s'\-]{2,}$/u.test(raw.trim());
}

function checkName(val: string, reqMsg: string, fmtMsg: string): string | undefined {
  if (!val.trim()) return reqMsg;
  if (!validName(val)) return fmtMsg;
}

function checkAge(val: string): string | undefined {
  if (!val) return "Required";
  const n = Number(val);
  if (!Number.isInteger(n) || n < 0 || n > 130) return "Must be a whole number between 0 and 130";
}

function checkAddress(val: string): string | undefined {
  if (!val.trim()) return "Required";
  if (val.trim().length < 5) return "Enter a complete address (min 5 characters)";
}

function checkCity(val: string): string | undefined {
  if (!val.trim()) return "Required";
  if (!/^[\p{L}\s\-]{2,}$/u.test(val.trim())) return "Letters and spaces only";
}

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity -- field-by-field validator; per-field extraction would relocate without reducing total complexity. Tracked under TASK-N19 Phase B.
export function validatePatientForm(f: {
  full_name: string; age: string; date_of_birth: string; primary_phone: string;
  emergency_contact_name: string; emergency_contact_phone: string;
  address: string; city: string; state: string; enrolment_date: string;
}): PatientFormErrors {
  const e: PatientFormErrors = {};
  const name = checkName(f.full_name, "Required", "Letters, spaces and hyphens only — no numbers");
  if (name) e.full_name = name;
  const age = checkAge(f.age);
  if (age) e.age = age;
  if (!f.date_of_birth) e.date_of_birth = "Required";
  else if (!/^\d{4}-\d{2}-\d{2}$/.test(f.date_of_birth)) e.date_of_birth = "Must be a valid date";
  if (!f.primary_phone) e.primary_phone = "Required";
  const ecName = checkName(f.emergency_contact_name, "Required", "Letters, spaces and hyphens only");
  if (ecName) e.emergency_contact_name = ecName;
  if (!f.emergency_contact_phone) e.emergency_contact_phone = "Required";
  const addr = checkAddress(f.address);
  if (addr) e.address = addr;
  const city = checkCity(f.city);
  if (city) e.city = city;
  if (!f.state.trim()) e.state = "Required";
  if (!f.enrolment_date) e.enrolment_date = "Required";
  return e;
}
